import type { ConfluenceCreatePageCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';

import type { ConfluencePageCreateCommandProcessor } from '../stream-processors/command-processors';

import { type PassThroughCommandProperties } from './types/command-handler-types';
import { StreamingCommandHandler } from './types/streaming-command-handler';

export class CreateCommandHandler extends StreamingCommandHandler<ConfluenceCreatePageCommandProperties> {
	private streamedAdf = '';

	constructor(
		properties: PassThroughCommandProperties,
		private createCommandProcessor: ConfluencePageCreateCommandProcessor,
	) {
		super(properties, 'create');
	}

	async process(params: ConfluenceCreatePageCommandProperties): Promise<void> {
		if (!params.data.adf) {
			return;
		}

		if (!params.isStreamComplete) {
			this.streamedAdf += params.data.adf;
			this.createCommandProcessor.stream(this.streamedAdf);
		}
	}

	async finish(): Promise<void> {
		const adfDoc = await this.createCommandProcessor.finish();
		if (adfDoc) {
			this.properties.editorAPI.core.actions.replaceDocument(adfDoc, {
				addToHistory: false,
				scrollIntoView: false,
			});
		}

		this.streamedAdf = '';
	}

	abort(): void {
		this.createCommandProcessor.abort();
	}
}
